
import "./index.css";
import { PrimaryButton } from "../Buttons";
import Logo from "../../assets/images/hangsushi-logo.webp";
import { Link } from "react-router-dom";

export function Header() {
  function handleOrderButton() {
    window.open("https://hangs-sushi.orderintelligence.no/no/welcome", "_blank");
  }
  return (
    <header className="text-white p-4 sticky top-0 bg-black z-10 opacity-90 ">
      <div className="  max-w-screen-xl mx-auto">
        <div className="flex justify-between">
        <Link to="/" className="self-center">
            <img src={Logo} alt="logo of hangs sushi in moelv ringsaker norway asian restaurant thai vietnamese cuisine" className="w-36 md:w-56" />
          </Link>
          <div className="flex content-center">
            <div className="self-center">
              <PrimaryButton label="bestill nå" onClick={handleOrderButton} />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
